<template>
  <div v-if="isShown" ref="referalMessage" class="mb-1.5">
    <div
      class="bg-neutral-100 dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-[12px] py-1.5 ltr:pl-3 ltr:pr-2 rtl:pr-3 rtl:pl-2 flex items-start gap-2 overflow-hidden"
    >
      <div class="self-stretch w-0.5 bg-green-300 flex-shrink-0 mt-0.5" />
      <div class="flex-grow min-w-0 flex flex-col gap-0.5">
        <span class="text-xs font-semibold text-green-700">
          {{ referralName }}
        </span>
        <span class="text-xs font-semibold text-gray-700 dark:text-slate-300">
          {{ referralTitle }}
        </span>
        <div class="text-xs text-gray-500 dark:text-slate-400">
          <letter class="text-content mb-2" :html="referralBody" />
        </div>
        <div class="text-xs text-gray-500 dark:text-slate-400">
          <letter class="text-content" :html="referralLink" />
        </div>
        <div class="text-xs text-gray-500 dark:text-slate-400">
          <letter class="text-content" :html="referralId" />
        </div>
        <div v-if="imageUrl && !hasImageError" class="mt-1">
          <bubble-image :url="imageUrl" @error="onImageLoadError" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGE_TYPE } from 'shared/constants/messages';
import Letter from 'vue-letter';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import BubbleImage from './Image.vue';

export default {
  name: 'Referral',
  components: { Letter, BubbleImage },
  mixins: [messageFormatterMixin],
  props: {
    referralData: {},
    data: {},
    confirmOpenExternalLink: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      hasImageError: false,
    };
  },
  computed: {
    isShown() {
      return !!this.referralData;
    },
    referralName() {
      return this.referralData.ref_type === 'post'
        ? this.$t('CONVERSATION.REFERRAL_MESSAGE.TYPE.POST')
        : this.$t('CONVERSATION.REFERRAL_MESSAGE.TYPE.AD');
    },
    referralTitle() {
      return this.referralData.ref_title;
    },
    referralBody() {
      const text =
        this.$t('CONVERSATION.REFERRAL_MESSAGE.TITLE.BODY') +
        ': ' +
        this.referralData.ref_body;
      return this.prepareText(text);
    },
    referralLink() {
      const text =
        this.$t('CONVERSATION.REFERRAL_MESSAGE.TITLE.LINK') +
        ': ' +
        this.referralData.ref_link;
      return this.prepareText(text);
    },
    referralId() {
      const text =
        this.$t('CONVERSATION.REFERRAL_MESSAGE.TITLE.ID') +
        ': ' +
        this.referralData.ref_id;
      return this.prepareText(text);
    },
    isIncoming() {
      return this.data?.message_type === MESSAGE_TYPE.INCOMING;
    },
    imageUrl() {
      return this.referralData.ref_image_url || this.referralData.ref_image;
    },
  },
  mounted() {
    // confirm-before-open for external/http links (skip mailto/tel/#)
    this.confirmLinkHandler = this.confirmOpenExternalLink.bind(this);
    const externalLinks = this.$refs.referalMessage?.querySelectorAll(
      'a[href]:not([href^="#"]):not([href^="tel:"]):not([href^="mailto:"])'
    );
    externalLinks?.forEach(link => {
      link.addEventListener('click', this.confirmLinkHandler);
    });
  },
  methods: {
    prepareText(text) {
      return this.formatMessage(
        text,
        this.isATweet,
        this.data.private,
        this.isAWhatsAppChannel
      );
    },
    onImageLoadError() {
      this.hasImageError = true;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .text-content {
    p:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
